module.exports = __webpack_public_path__ + "static/media/orderError.fb73fd4e.svg";